import React, { useEffect, useRef, useState } from "react";
import Spinner from "../../components/spinner/spinner";
import { Dropdown } from "primereact/dropdown";
import styles from "./KrogerInvoiceConfig.module.scss";
import { useFormik } from "formik";
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Toast } from "primereact/toast";
import * as constants from "../../constants/constants";
import { InputSwitch } from "primereact/inputswitch";
import { krogerRetailColumns } from "../../constants/table-columns/tableColumns";
import {
  getKrogerOrderDeatils,
  getKrogerRegions,
  switchKrogerInvoice,
  updateKrogerInvoiceConfig
} from "../../services/KrogerInvoiceConfigService";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { ConfirmDialog } from "primereact/confirmdialog";
import { appInsights } from "../../AppInsights";

const KrogerInvoiceConfig = () => {
  const toast = useRef(null);
  const [regions, setRegions] = useState([]);
  const [tradingPartners, setTradingPartners] = useState([]);
  const [krogerCreditData, setKrogerCreditData] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [currentPageRows, setCurrentPageRows] = useState(10);
  const [visible, setVisible] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [invoiceAccountsText, setInvoiceAccountsText] = useState("");
  const [selectedToggleId, setSelectedToggleId] = useState(null);
  const [handleToggleDialogVisible, setHandleToggleDialogVisible] =
    useState(false);
  const [showSpinner, setShowSpinner] = useState(false);

  const initialValues = {
    regionCode: null,
    tradingPartnerName: null,
    isEnabled: null
  };

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const fetchRegions = async () => {
    try {
      const response = await getKrogerRegions();
      setRegions(response);
    } catch (error) {
      console.error("Error fetching regions:", error);
    }
  };
  const fetchKrogerOrderDetails = async (values) => {
    try {
      setShowSpinner(true);
      const response = await getKrogerOrderDeatils(values);
      setKrogerCreditData(response);
      setShowSpinner(false);
    } catch (error) {
      setShowSpinner(false);
      toast?.current?.show({
        severity: "error",
        summary: "Error",
        detail: error?.message,
        life: 4000
      });
      appInsights.trackException({
        exception: error,
        properties: {
          additionalInfo:
            "Error while fetching kroger invoice data"
        },
        measurements: {
          severityLevel: 2
        }
      });
    }
  };
  useEffect(() => {
    fetchRegions();
    fetchKrogerOrderDetails(formik?.values);
  }, []);
  const modes = [
    { EnableDisable: "Enable", value: true },
    { EnableDisable: "Disable", value: false }
  ];
  const itemModificationOptions = [
    { label: "Add Item", value: "Add Item" },
    { label: "Modify Item", value: "Modify Item" }
  ];
  const formik = useFormik({
    initialValues,
    onSubmit: (values) => {
      setCurrentPage(0);
      setCurrentPageRows(10);
      setShowSpinner(true);
      fetchKrogerOrderDetails(values);
    },
    validateOnBlur: true,
    validateOnChange: true
  });

  const formRef = useRef(formik);
  const formikRef = useRef(formik);
  useEffect(() => {
    formikRef.current = formik;
  }, [formik]);

  const updateKrogerOrderDetails = async (values) => {
    try{
      setShowSpinner(true);
      const response = await updateKrogerInvoiceConfig(values);
      if (!!response) {
        toast?.current?.show({
          severity: "success",
          summary: "Success",
          detail: response,
          life: 3000
        });
        setVisible(false);
        fetchKrogerOrderDetails(formikRef.current?.values);
      }
    }catch(error){
      setShowSpinner(false);
      toast?.current?.show({
        severity: "error",
        summary: "Error",
        detail: error?.message,
        life: 4000
      });
      appInsights.trackException({
        exception: error,
        properties: {
          additionalInfo:
            "Error while editing kroger invoice"
        },
        measurements: {
          severityLevel: 2
        }
      });
    }
  }
  const editFormik = useFormik({
    enableReinitialize: true,
    initialValues: {
    id: selectedRowData?.id ?? 0,
    regionCode: selectedRowData?.regionCode ?? "",
    tradingPartnerName: selectedRowData?.tradingPartnerName ?? "",
    isEnabled: selectedRowData?.isEnabled ?? false,
    actionType: selectedRowData?.actionType ?? "",
    invoiceAccounts: invoiceAccountsText
  },
    onSubmit: async (values) => {
         const payload = {
      ...values,
      invoiceAccounts: invoiceAccountsText
        .split(",")
        .map(item => item.trim())
        .filter(item => item !== "")
    };
      updateKrogerOrderDetails(payload);
    }
      
  });
  const InvoiceAccountTemplate = (rowData) => {
    return rowData?.invoiceAccounts
      ?.map((item) => item?.invoiceAccount)
      ?.join(", ");
  };

  const ActionTemplate = (rowData) => {
    return (
      <Button
        label="Edit"
        icon="pi pi-pencil"
        className={styles.editBtn}
        onClick={() => handleEdit(rowData)}
      />
    );
  };
  const handleEdit = (rowData) => {
    setVisible(true);
    setSelectedRowData(rowData);
    setInvoiceAccountsText(
      rowData.invoiceAccounts?.map((item) => item.invoiceAccount).join(", ")
    );
  };
  const ToggleBtn = (rowData) => {
    return (
      <div>
        <InputSwitch
          checked={rowData?.isEnabled}
          onChange={() => {
            setHandleToggleDialogVisible(true);
            setSelectedToggleId(rowData?.id);
          }}
          className={styles?.switchProps}
        />
      </div>
    );
  };
  const handleCloseToggleDialog = () => {
    setHandleToggleDialogVisible(false);
  };
  const approveOrRejectKrogerConfigChange = async () => {
    try {
      const response = await switchKrogerInvoice(selectedToggleId);
      if (!!response) {
        toast?.current?.show({
          severity: "success",
          summary: "Success",
          detail: response,
          life: 3000
        });
        fetchKrogerOrderDetails(formikRef.current?.values);
      }
    } catch (error) {
      setShowSpinner(false);
      toast?.current?.show({
        severity: "error",
        summary: "Error",
        detail: error?.message,
        life: 4000
      });
      appInsights.trackException({
        exception: error,
        properties: {
          additionalInfo:
            "Error while enable/disable automated kroger flow config setting"
        },
        measurements: {
          severityLevel: 2
        }
      });
    }
  };

  return (
    <div>
      {showSpinner && <Spinner />}
      <ConfirmDialog
        visible={handleToggleDialogVisible}
        onHide={handleCloseToggleDialog}
        message={
          "Are you sure you want to change the Kroger Invoice configuration?"
        }
        header="Confirmation"
        icon="pi pi-exclamation-triangle"
        accept={approveOrRejectKrogerConfigChange}
        reject={handleCloseToggleDialog}
      />
      <form onSubmit={formik.handleSubmit} ref={formRef}>
        <div className="grid p-fluid">
          <div className="col-12 md:col-2">
            <div className={styles?.formLabelContainer}>
              <label htmlFor="Region">
                <span className={styles.formLabel}>Region</span>
              </label>
            </div>
            <Dropdown
              id="Region"
              filter
              showClear
              options={regions}
              placeholder="Region"
              optionLabel="region"
              optionValue="region"
              value={formik?.values?.regionCode}
              className={styles.dropdown}
              onChange={(e) => {
                formik.setFieldValue("regionCode", e.value);
                const matchedRegion = regions.find(
                  (item) => item.region === e.value
                );
                setTradingPartners(
                  matchedRegion ? matchedRegion.tradingPartners : []
                );
                formik.setFieldValue("tradingPartnerName", null);
              }}
              onBlur={formik.handleBlur}
            />
          </div>
          <div className="col-12 md:col-2">
            <div className={styles?.formLabelContainer}>
              <label htmlFor="tradingPartnerName">
                <span className={styles.formLabel}>Trading Partner</span>
              </label>
            </div>
            <Dropdown
              id="tradingPartnerName"
              filter
              showClear
              placeholder="Trading Partner"
              optionLabel="tradingPartnerDisplayName"
              optionValue="tradingPartnerName"
              options={tradingPartners}
              value={formik?.values?.tradingPartnerName}
              className={styles?.dropdown}
              onChange={async (e) => {
                formik.setFieldValue("tradingPartnerName", e?.value);
              }}
              onBlur={formik.handleBlur}
            />
          </div>
          <div className="col-12 md:col-2">
            <div className={styles?.formLabelContainer}>
              <label htmlFor="EnableDisable">
                <span className={styles.formLabel}>Enable/Disable</span>
              </label>
            </div>
            <Dropdown
              id="EnableDisable"
              filter
              showClear
              options={modes}
              placeholder="All"
              optionLabel="EnableDisable"
              optionValue="value"
              value={formik?.values?.isEnabled}
              className={styles.dropdown}
              onChange={(e) => formik.setFieldValue("isEnabled", e?.value)}
              onBlur={formik.handleBlur}
            />
          </div>

          <div
            className="col-12 md:col-6 gap-3"
            style={{ marginTop: "2.5rem" }}
          >
            <div className="grid">
              <div className="col-12 md:col-3 ">
                <Button
                  label="Search"
                  type="submit"
                  size="medium"
                  className={styles?.primaryBtn}
                />
              </div>
              <div className="col-12 md:col-3 ">
                <Button
                  label="Reset"
                  type="button"
                  size="medium"
                  onClick={() => {
                    setRegions(regions);
                    formik.setValues({
                      tradingPartnerName: null,
                      isEnabled: null,
                      region: null
                    });
                    fetchKrogerOrderDetails({
                      tradingPartnerName: null,
                      isEnabled: null,
                      regionCode: null
                    });
                  }}
                  className={styles?.resetBtn}
                />
              </div>
            </div>
          </div>
        </div>
      </form>
      <br></br>

      <DataTable
        value={krogerCreditData}
        tableStyle={{ minWidth: "50rem" }}
        scrollable
        first={currentPage}
        rows={currentPageRows}
        onPage={(e) => {
          setCurrentPage(e.first);
          setCurrentPageRows(e?.rows);
        }}
        paginator={constants?.paginator}
        rowsPerPageOptions={constants?.rowsPerPageOptions}
        paginatorTemplate={constants?.paginatorTemplate}
        currentPageReportTemplate={constants?.currentPageReportTemplate}
        emptyMessage={constants?.emptyMessage}
        dataKey="id"
        scrollHeight="30vw"
      >
        {krogerRetailColumns?.map((col, index) => (
          <Column
            key={index}
            field={col.field}
            header={col.header}
            sortable={col.sort}
            style={{ minWidth: col.minWidth }}
            body={
              col.field.toLowerCase() === "action"
                ? ActionTemplate
                : col.field.toLowerCase() === "enabledisable"
                  ? ToggleBtn
                  : col.field.toLowerCase() === "invoiceaccounts"
                    ? InvoiceAccountTemplate
                    : undefined
            }
          />
        ))}
      </DataTable>

      <Toast ref={toast} position="center" />
      <Dialog
        header="Edit Record"
        style={{ width: "35vw" }}
        visible={visible}
        onHide={() => setVisible(false)}
      >
        <form onSubmit={editFormik.handleSubmit}>
          <div className="grid p-fluid">
            <div className="col-12">
              <div className={styles?.formLabelContainer}>
                <label htmlFor="Region">
                  <span className={styles.formLabel}>Region</span>
                </label>
              </div>
              <InputText
                id="Region"
                value={selectedRowData?.regionCode}
                disabled
              />
            </div>
            <div className="col-12">
              <div className={styles?.formLabelContainer}>
                <label htmlFor="TradingPartner">
                  <span className={styles.formLabel}>Trading Partner</span>
                </label>
              </div>
              <InputText
                id="TradingPartner"
                value={selectedRowData?.tradingPartnerName}
                disabled
              />
            </div>
            <div className="col-12">
              <div className={styles?.formLabelContainer}>
                <label htmlFor="InvoiceAccounts">
                  <span className={styles.formLabel}>Invoice Accounts</span>
                </label>
              </div>
              <InputText
                id="InvoiceAccounts"
                value={invoiceAccountsText}
                onChange={(e) => setInvoiceAccountsText(e.target.value)}
              />
            </div>
            <div className="col-12">
              <div className={styles?.formLabelContainer}>
                <label htmlFor="enabledisable">
                  <span className={styles.formLabel}>Enable/Disable</span>
                </label>
              </div>
              <Dropdown
                id="EnableDisable"
                filter
                options={modes}
                placeholder="All"
                optionLabel="EnableDisable"
                optionValue="value"
                value={selectedRowData?.isEnabled}
                className={styles.dropdown}
                onChange={(e) =>
                  setSelectedRowData((prev) => ({
                    ...prev,
                    isEnabled: e.value
                  }))
                }
              />
            </div>
            <div className="col-12">
              <div className={styles?.formLabelContainer}>
                <label htmlFor="itemmodification">
                  <span className={styles.formLabel}>Item Modification</span>
                </label>
              </div>
              <Dropdown
                id="itemmodification"
                filter
                options={itemModificationOptions}
                value={selectedRowData?.actionType}
                className={styles.dropdown}
               onChange={(e) =>
                  setSelectedRowData((prev) => ({
                    ...prev,
                    actionType: e.value
                  }))
                }
              />
            </div>
            <div className="col-12">
              <div className="flex justify-content-end gap-2">
                <Button
                  label="Cancel"
                  type="button"
                  className={`${styles.krogercancel_btn}`}
                  onClick={() => setVisible(false)}
                />
                <Button
                  label="Save Changes"
                  className={styles.krogersave_btn}
                />
              </div>
            </div>
          </div>
        </form>
      </Dialog>
    </div>
  );
};

export default KrogerInvoiceConfig;
